import React from 'react'
import {
  Card,
  Divider,
  Grid,
  Typography,
} from '@mui/material'

type Props = {
  breachDetectiveResults: any[]
}

const Field = ({ label, value }: { label: string; value?: any }) => {
  const text = Array.isArray(value)
    ? value.filter(Boolean).join(', ')
    : value

  if (!text) {
    return null
  }

  return (
    <Grid item xs={6}>
      <Grid
        container={String(text).length < 35}
        sx={{
          display: 'flex',
          overflow: 'hidden',
        }}
      >
        <Grid item xs={4}>
          <Typography
            variant="text"
            fontSize={14}
            sx={{ wordBreak: 'break-all' }}
          >
            {label}:
          </Typography>
        </Grid>

        <Grid item xs={8}>
          <Typography
            variant="bold"
            sx={{
              wordBreak: 'break-all',
              whiteSpace: 'pre-line',
            }}
          >
            {text}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default function BreachDetectiveResultsViewer({
  breachDetectiveResults,
}: Props) {
  if (
    !Array.isArray(breachDetectiveResults) ||
    breachDetectiveResults.length === 0
  ) {
    return null
  }

  return (
    <Card sx={{ p: 2, borderRadius: 2 }}>
      <Grid container spacing={1} sx={{ width: '100%' }}>
        {breachDetectiveResults.map((item: any, resultIndex: number) => {
          const breachDetective = item?.breachDetective ?? item

          if (!breachDetective) {
            return null
          }

          const records = Array.isArray(breachDetective.records)
            ? breachDetective.records
            : []

          return (
            <React.Fragment
              key={`${item?.request || breachDetective?.title || 'breach'}-${resultIndex}`}
            >
              {resultIndex > 0 && (
                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }} />
                </Grid>
              )}

              <Field
                label="Query"
                value={
                  breachDetective?.query?.value ||
                  breachDetective?.title
                }
              />

              <Field
                label="Records"
                value={breachDetective?.count ?? records.length}
              />

              {records.map((record: any, recordIndex: number) => {
                const availableData = record?.availableData || {}

                return (
                  <React.Fragment
                    key={`${record?.breachSource || 'source'}-${recordIndex}`}
                  >
                    {(recordIndex > 0 || resultIndex > 0) && (
                      <Grid item xs={12}>
                        <Divider sx={{ my: 1 }} />
                      </Grid>
                    )}

                    <Field
                      label="Source"
                      value={record?.breachSource}
                    />

                    <Field
                      label="Date"
                      value={record?.breachDate}
                    />

                    <Field
                      label="Email"
                      value={availableData.email}
                    />

                    <Field
                      label="Username"
                      value={availableData.username}
                    />

                    <Field
                      label="Password"
                      value={availableData.password}
                    />

                    <Field
                      label="Phone"
                      value={availableData.phone}
                    />

                    <Field
                      label="Name"
                      value={availableData.name}
                    />

                    <Field
                      label="Address"
                      value={availableData.address}
                    />

                    <Field
                      label="Birthday"
                      value={availableData.dateOfBirth}
                    />

                    <Field
                      label="IP"
                      value={availableData.ipAddress}
                    />
                  </React.Fragment>
                )
              })}
            </React.Fragment>
          )
        })}
      </Grid>
    </Card>
  )
}